import { Component, AfterViewInit, ChangeDetectorRef, Input, OnChanges, Output, EventEmitter, ViewChild, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { ResultMailService } from '../../../service/result-mail/result-mail.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9151',
  templateUrl: 'wa9151.component.html',
  styleUrls: ['wa9151.component.scss']
})
export class Wa9151Component implements OnInit, OnChanges {
  public componentTitle = 'WA9151:実績メールマスタ修正';

  public ownerId: number;
  public ownerCd: string;
  public ownerTx: string;
  public reportCd: string;
  public reportTx: string;
  public mailfromTx: FormControl;
  public mailtoTx: FormControl;
  public mailccTx: FormControl;
  public mailsubjectTx: FormControl;
  public mailbodyTx: FormControl;
  public fileTx: FormControl;
  public sendTm: FormControl;
  public errorInfo = '';
  public validation = validation;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  @Input() isShow = false;
  private isDelayHide = true;
  @Output() closeButtonClick = new EventEmitter<boolean>();

  public mailfromTxActive;
  public mailfromTxError;
  public mailtoTxActive;
  public mailtoTxError;
  public mailccTxActive;
  public mailccTxError;
  public mailsubjectTxActive;
  public mailsubjectTxError;
  public mailbodyTxActive;
  public mailbodyTxError;
  public fileTxActive;
  public fileTxError;
  public sendTmActive;
  public sendTmError;

  private loca = null;

  private isUpdateButtonEnabled = false;

  constructor(private router: Router, private resultMailService: ResultMailService, private commonService: CommonService, private dialogsService: DialogsService) {
    const resultmail: object = JSON.parse(sessionStorage.getItem('resultmail'));

    (this.mailfromTx = new FormControl('', [
      Validators.required,
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.MailAddress),
      Validators.maxLength(validation.mailfromTx.maxLength)
    ])),
      (this.mailtoTx = new FormControl('', [
        Validators.required,
        Validators.pattern(validation.halfBlankOnly),
        Validators.pattern(validation.multiMailAddress),
        Validators.maxLength(validation.mailtoTx.maxLength)
      ])),
      (this.mailccTx = new FormControl('', [
        Validators.pattern(validation.halfBlankOnly),
        Validators.pattern(validation.multiMailAddress),
        Validators.maxLength(validation.mailccTx.maxLength)
      ])),
      (this.mailsubjectTx = new FormControl('', [
        Validators.required,
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.mailsubjectTx.maxLength)
      ])),
      (this.mailbodyTx = new FormControl('', [Validators.maxLength(validation.mailbodyTx.maxLength)])),
      (this.fileTx = new FormControl('', [
        Validators.required,
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.fileTx.maxLength)
      ])),
      (this.sendTm = new FormControl('')),
      (this.containerHeight = window.innerHeight - config.containerheaderMargin);

    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() { }

  onSubmit() {
    if (!this.isUpdateButtonEnabled) return;

    var mailfromTx = this.mailfromTx.value.trim();
    var mailtoTx = this.mailtoTx.value.trim();
    var mailccTx = this.mailccTx.value.trim();
    var mailsubjectTx = this.mailsubjectTx.value.trim();
    var mailbodyTx = this.mailbodyTx.value.trim();
    var fileTx = this.fileTx.value.trim();
    var sendTm = this.sendTm.value;
    let errors = false;
    if (this.mailfromTx.errors !== null) {
      this.mailfromTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.mailtoTx.errors !== null) {
      this.mailtoTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.mailccTx.errors !== null) {
      this.mailccTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.mailsubjectTx.errors !== null) {
      this.mailsubjectTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.mailbodyTx.errors !== null) {
      this.mailbodyTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.fileTx.errors !== null) {
      this.fileTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.resultMailService
      .put(this.ownerId, this.reportCd, mailfromTx, mailtoTx, mailccTx, mailsubjectTx, mailbodyTx, fileTx, sendTm, 'WA9151')
      .then(outputJson => {
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }
  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    } else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    const resultmail: object = JSON.parse(sessionStorage.getItem('resultmail'));
    this.loca = resultmail;

    this.ownerId = resultmail['ownerId'];
    this.ownerCd = resultmail['ownerCd'];
    this.ownerTx = resultmail['ownerTx'];
    this.reportCd = resultmail['reportCd'];
    this.reportTx = resultmail['reportTx'];
    this.errorInfo = '';
    var mailfromTx = resultmail['mailfromTx'];
    var mailtoTx = resultmail['mailtoTx'];
    var mailccTx = resultmail['mailccTx'];
    var mailsubjectTx = resultmail['mailsubjectTx'];
    var mailbodyTx = resultmail['mailbodyTx'];
    var fileTx = resultmail['fileTx'];
    var sendTm = resultmail['sendTm'];

    this.mailfromTx.setValue(mailfromTx);
    this.mailtoTx.setValue(mailtoTx);
    this.mailccTx.setValue(mailccTx);
    this.mailsubjectTx.setValue(mailsubjectTx);
    this.mailbodyTx.setValue(mailbodyTx);
    this.fileTx.setValue(fileTx);
    this.sendTm.setValue(sendTm);
  }

  close9151() {
    this.closeButtonClick.emit(true);
  }
  cancel() {
    this.errorInfo = '';

    this.closeButtonClick.emit(false);
    sessionStorage.removeItem('resultmail');
  }

  ngDoCheck() {
    if (!this.isShow) return;
    const resultmail: object = JSON.parse(sessionStorage.getItem('resultmail'));
    this.mailfromTxActive = resultmail['mailfromTx'] !== this.mailfromTx.value.trim() ? 'active' : '';
    this.mailfromTxError = this.mailfromTx.errors !== null ? 'error' : '';

    this.mailtoTxActive = resultmail['mailtoTx'] !== this.mailtoTx.value.trim() ? 'active' : '';
    this.mailtoTxError = this.mailtoTx.errors !== null ? 'error' : '';

    this.mailccTxActive = resultmail['mailccTx'] !== this.mailccTx.value.trim() ? 'active' : '';
    this.mailccTxError = this.mailccTx.errors !== null ? 'error' : '';

    this.mailsubjectTxActive = resultmail['mailsubjectTx'] !== this.mailsubjectTx.value.trim() ? 'active' : '';
    this.mailsubjectTxError = this.mailsubjectTx.errors !== null ? 'error' : '';

    this.mailbodyTxActive = resultmail['mailbodyTx'] !== this.mailbodyTx.value.trim() ? 'active' : '';
    this.mailbodyTxError = this.mailbodyTx.errors !== null ? 'error' : '';

    //fileTx
    this.fileTxActive = resultmail['fileTx'] !== this.fileTx.value.trim() ? 'active' : '';
    this.fileTxError = this.fileTx.errors !== null ? 'error' : '';

    if (this.sendTm.value !== null) {
      this.sendTmActive = resultmail['sendTm'] !== this.sendTm.value.trim() ? 'active' : '';
      this.sendTmError = this.sendTm.errors !== null ? 'error' : '';
    }
    this.checkUpdateButtonState();
  }

  checkUpdateButtonState() {
    if (!this.mailfromTxError && !this.mailtoTxError && !this.mailccTxError && this.mailsubjectTxError !== 'error' && this.mailbodyTxError !== 'error' && !this.fileTxError && !this.sendTmError) {
      this.isUpdateButtonEnabled = this.mailfromTxActive || this.mailtoTxActive || this.mailccTxActive || this.mailsubjectTxActive || this.mailbodyTxActive || this.fileTxActive || this.sendTmActive;
    } else this.isUpdateButtonEnabled = false;
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9151/wa9151.component.ts